import { InjectionToken } from "@angular/core";

export const ISession_Service_Token = new InjectionToken<ISessionSerivce>(
  "sessionService"
);

export interface ISessionSerivce {
  currentUser(): { id: number, userName: string, firstName: string, lastName: string, fullName: string };
  isInShadow(): boolean;
}